import { ROLEPLAY_CONTEXT, BASE_CONTEXT_V2_ROLEPLAY } from "./api-context";

export const ROLEPLAY = {
    SCENARIOS:{
        SCENARIO_LIST: (bu:string, region:string)=>`${ROLEPLAY_CONTEXT}rollplay_scenario_list/${bu}`,
        GENERATE_EVALUATION_SKILLS:`${ROLEPLAY_CONTEXT}generate-and-save`,

        COACH_RESPONSE: (chatSessionId: number) => `${ROLEPLAY_CONTEXT}roleplay_bot_as_user_response?chat_session_id=${chatSessionId}`,

        CREATE:`${BASE_CONTEXT_V2_ROLEPLAY}create_roleplay_scenario`,
        LIST: (bu:string, region:string)=>`${BASE_CONTEXT_V2_ROLEPLAY}roleplay_scenario_list?business_unit_code=${bu}&region_code=${region}`,
        BY_ID: (scenario_id:number)=>`${BASE_CONTEXT_V2_ROLEPLAY}get_roleplay_scenario/${scenario_id}`,
        UPDATE: (scenario_id:number)=>`${BASE_CONTEXT_V2_ROLEPLAY}update_roleplay_scenario/${scenario_id}`,
        DELETE: (scenario_id:number)=>`${BASE_CONTEXT_V2_ROLEPLAY}delete_roleplay_scenario/${scenario_id}`,
        UPDATE_COACH_ASSIST: (scenario_id:number)=>`${BASE_CONTEXT_V2_ROLEPLAY}update_roleplay_scenario_coach_assistance/${scenario_id}`,
        METRICS: (bu:string, region:string)=>`${BASE_CONTEXT_V2_ROLEPLAY}roleplay_scenario_metrics?business_unit_code=${bu}&region=${region}`,
        UPDATE_FAVORITE: `${BASE_CONTEXT_V2_ROLEPLAY}update_roleplay_scenario_favorite`,
        UPDATE_STATUS: `${BASE_CONTEXT_V2_ROLEPLAY}update_roleplay_scenario_status`,
        INFO: (bu:string, region:string, scenario_id:number)=>`${BASE_CONTEXT_V2_ROLEPLAY}roleplay_scenarios_assignments_details?business_unit_code=${bu}&region=${region}&scenario_id=${scenario_id}`,
    },
    FEEDBACK_USER_EVAL: {
        CREATE: `${BASE_CONTEXT_V2_ROLEPLAY}create_dynamic_feedback_user_eval`,
        UPDATE: `${BASE_CONTEXT_V2_ROLEPLAY}update_dynamic_feedback_user_eval`,
        LIST: (bu:string, region:string)=>`${BASE_CONTEXT_V2_ROLEPLAY}list_dynamic_feedback_user_eval?business_unit_code=${bu}&region_code=${region}`,
        MATCH: `${BASE_CONTEXT_V2_ROLEPLAY}match_dynamic_feedback_user_eval`,
    },

    COACH:{
        RESPONSE: (chatSessionId: number) => `${ROLEPLAY_CONTEXT}roleplay_bot_as_user_response?chat_session_id=${chatSessionId}`
    }

}